import api from "services/api";

// Get all requisitions
export const getRequisitions = async () => {
  return api.get("/v1/api/get-requisition-list");
};

// Get requisition details
export const getRequisitionDetails = async (requisitionId) => {
  return api.get(`/v1/api/get-requisition/${requisitionId}`);
};

// Create a new requisition
export const createRequisition = async (requisitionData) => {
  return api.post("/v1/api/create-requisition", requisitionData);
};

// Approve or reject a requisition
export const approveRejectRequisition = async (requisitionId, actionData) => {
  if (actionData instanceof FormData) {
    return api.put(
      `/v1/api/approve-reject-requisition/${requisitionId}`,
      actionData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }
  return api.put(
    `/v1/api/approve-reject-requisition/${requisitionId}`,
    actionData,
  );
};
// Get requisitions created by logged-in user
export const getMyRequisitions = async () => {
  return api.get("/v1/api/get-my-requisitions");
};

// Update an existing requisition
export const updateRequisition = async (requisitionId, requisitionData) => {
  return api.put(`/v1/api/update-requisition/${requisitionId}`, requisitionData);
};

// Delete a requisition
export const deleteRequisition = async (requisitionId) => {
  return api.delete(`/v1/api/delete-requisition/${requisitionId}`);
};


// Get requisition master items (with optional project_id query param)
export const getRequisitionMasterItems = async (projectId = null) => {
  const url = projectId
    ? `/v1/api/get-requisition-master-items?project_id=${projectId}`
    : "/v1/api/get-requisition-master-items";
  return api.get(url);
};

/* =====================================================
   WORKFLOW LAYOUT SERVICES
===================================================== */

// Get company workflow layout steps
export const getRequisitionWorkflow = async () => {
  return api.get("/v1/api/requisition-workflow");
};

// Save company workflow layout steps
export const saveRequisitionWorkflow = async (steps) => {
  return api.post("/v1/api/requisition-workflow", { steps });
};

// Get approver options (departments, roles, employees)
export const getRequisitionWorkflowApproverOptions = async () => {
  return api.get("/v1/api/requisition-workflow/approver-options");
};


